export default "__VITE_ASSET__D_AGeN0N__"